import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('DRAWER', {
  TOGGLE: null
});
